/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Image, Space } from "antd";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { deliveryLineHead } from '../../../../../../config/constant';
import { TableCell, TableRow, TextField, Checkbox } from "@mui/material";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import { DeliveryLineForm } from "./DeliveryLineForm";
import { emptyValidation } from "../../../../../../helpers/validation";


export const DeliveryLinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, lines, getColumnWidth, currencyFormat, lineSubmit, form, hsnApi, handleClick, selected, idNamingConversion, changeHandlerLine } = props;
    const [lineId, setLineId] = useState('');
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('Add');
    const [view, setView] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [batch, setBatch] = useState([]);


    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        setBatch(data?.batchDetails);
        setLineForm(data);
        hsnApi('', data?.hsnId || '');
    }

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineForm({
            includeGst: form?.includeGst,
        });
        setBatch([]);
        hsnApi();
        setLineId('');
        setLineError({});
    }


    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyDeliverNow = emptyValidation('deliver_now', lineForm?.deliver_now);
        setLineError({});
        let batchQuantityError = { isValid: true, errors: '' };
        if (batch && batch?.length > 0) {
            let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);

            //let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.deliver_now)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }
        }

        if (emptyDeliverNow.isValid && batchQuantityError?.isValid) {
            if (batch?.length > 0) {
                let aL = [];
                batch?.map((element, i) => {
                    element.purchaseQuantity = parseFloat(element?.purchaseQuantity || 0);
                    return aL.push(element)
                });
                lineForm["batchDetails"] = aL;
            }
            lineSubmit(lineForm, lineId);
            handleOpen();
        } else {
            setLineError({
                deliverNow: emptyDeliverNow?.errors || false,
                batchQuantity: batchQuantityError?.errors || false
            })
        }
    }


    const changeHandlerBatch = (data, e, name, i) => {
        // Create a shallow copy of the array
        const updatedArr = [...batch];

        // Update the specific element immutably
        updatedArr[i] = {
            ...updatedArr[i],
            [name]: e,
        };

        // Update state with the new array
        setBatch(updatedArr);
    };

    const changeHandler = (e, name = '') => {
        let d = {
            ...lineForm,
            [name]: e,
            'available_quantity': parseFloat(parseFloat(lineForm.duplicate_available_quantity) - parseFloat(e))
        };
        setLineForm({ ...d });
    }

    return (
        <>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={deliveryLineHead}
                    width={true}
                    component={
                        <>
                            {
                                lines?.length > 0 ? lines.map((data, i) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 1) }}>
                                            {
                                                data?.duplicate_available_quantity === 0 ? <Checkbox checked={selected.find(e => e === data.id) ? true : false}
                                                    disabled={true} /> : <Checkbox checked={selected.find(e => e === data.id) ? true : false}
                                                        onChange={(e) => handleClick(data)} />
                                            }
                                        </TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 1) }}><span style={{ width: getColumnWidth(deliveryLineHead, 0) }}>{data?.lineNumber}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 2) }}><NavLink style={{ width: getColumnWidth(deliveryLineHead, 1) }} to={"#"} onClick={() => onEdit(data, i, true)} className={clsx(classes.bold, classes.color)}><span className={classes.descEllipsis}>{data.description}</span></NavLink></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 3) }}><span style={{ width: getColumnWidth(deliveryLineHead, 2) }}>{data?.quantity || '---'}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 4) }}><span style={{ width: getColumnWidth(deliveryLineHead, 4) }}>{data.unit?.name || '---'}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(deliveryLineHead, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(deliveryLineHead, 6) }}>
                                            {`₹ ${(data.discountAmount || data.discountPercent) ?
                                                (data.quantity < 0 ?
                                                    currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))) :
                                                    currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))))
                                                : currencyFormat(0)}`}
                                        </span>
                                        </TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(deliveryLineHead, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 8) }}><span style={{ width: getColumnWidth(deliveryLineHead, 8) }}>{data?.deliver_quantity}</span></TableCell>
                                        <TableCell style={{ width: getColumnWidth(deliveryLineHead, 9) }}><span style={{ width: getColumnWidth(deliveryLineHead, 9) }}>{data?.available_quantity}</span></TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell)} style={{ width: getColumnWidth(deliveryLineHead, 10) }}><span style={{ width: getColumnWidth(deliveryLineHead, 10) }}>
                                            {
                                                selected.find(e => e === data.id) && !data?.batchDetails ? <TextField autoComplete='one-time-code'
                                                    fullWidth
                                                    type={'number'}
                                                    className={clsx(classes.storeSalesLineQuantity, classes.storeSalesLinePrice)}
                                                    value={data?.deliver_now || ''}
                                                    InputProps={{
                                                        classes: {
                                                            input: clsx(classes.textFieldColor, classes.textAlignLeft),
                                                        }
                                                    }}
                                                    inputProps={{
                                                        step: "any"
                                                    }}
                                                    id={idNamingConversion('Deliver Quantity', 'salesOrderLine', 'TextField')}
                                                    onWheel={(e) => e.target.blur()}
                                                    InputLabelProps={{ className: classes.textAreaLableColorCustom }}
                                                    onFocus={(e) => e.target.select()}
                                                    onChange={(e) => {
                                                        if (e.target.value === '' || e.target.value < 0) {
                                                            changeHandlerLine(data, 0, 'deliver_now');
                                                        } else if (parseFloat(e.target.value) <= parseFloat(data.duplicate_available_quantity)) {
                                                            changeHandlerLine(data, parseFloat(e.target.value), 'deliver_now');
                                                        }
                                                    }}
                                                /> : data?.deliver_now
                                            }
                                        </span></TableCell>
                                        <TableCell>
                                            {
                                                data?.batchDetails ? data?.batchDetails?.map(el => el.batchNumber).join(", ") : '---'
                                            }
                                        </TableCell>
                                        <TableCell className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                    <Image
                                                        src={ViewIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                                {
                                                    data?.duplicate_available_quantity > 0 && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                        <Image
                                                            src={EditIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={11}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Delivery'}</p>
                                    </TableCell>
                                </TableRow>
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Order Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <DeliveryLineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        lineError={lineError}
                        batch={batch}
                        changeHandlerBatch={(data, e, name, i) => changeHandlerBatch(data, e, name, i)}
                        handleEdit={(v) => setView(v)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        changeHandler={(e, name) => changeHandler(e, name)}

                    />
                }
            />
        </>
    )
})